import { NavLink } from "react-router-dom";

export default function SidebarPagesList(){
    return(
        <ul>
            <li>
                <NavLink to={"Barriers"}>Barriers</NavLink>
            </li>
            <li>
                <NavLink to={"Joys"}>Joys</NavLink>
            </li>
            <li>
                <NavLink to={"Fear"}>Fear</NavLink>
            </li>
            <li>
                <NavLink to={"Joys2"}>Joys II</NavLink>
            </li>
            <li>
                <NavLink to={"Lost&Found"}>Lost/Found</NavLink>
            </li>
            <li>
                <NavLink to={"Milestones"}>Milestones</NavLink>
            </li>
        </ul>
    )
}